import React, { memo } from 'react';
import { List } from '@fourthwall/components';
import { ProductsListItem } from '../ProductsListItem/ProductsListItem';
const MemoizedProductsListItem = memo(ProductsListItem);
export const ProductsList = memo(({ items, hasNextPage, multiple, selectMode, innerIds, mode, productsStates, onSelect, onBulkSelect, }) => {
    const getValue = (item) => {
        if (multiple) {
            if (selectMode === 'VARIANTS' && item.type === 'OFFER') {
                return !!innerIds.find((innerId) => item.variantsIds.includes(innerId));
            }
            return !!innerIds.find((innerId) => item.id === innerId);
        }
        return innerIds[0]?.toString();
    };
    const getDisabled = (item) => {
        if (mode === 'INVENTORY_SHIPMENT' && item.type !== 'VARIANT') {
            return !item.hasHsCode;
        }
        return productsStates[item.id]?.disabled.value;
    };
    const getDisabledMessage = (item) => {
        if (mode === 'INVENTORY_SHIPMENT')
            return;
        return productsStates[item.id]?.disabled.message;
    };
    return (React.createElement(List, { data: items, bottomBorder: hasNextPage, renderItem: (item) => (React.createElement(MemoizedProductsListItem, { key: item.id, item: item, multiple: multiple, value: getValue(item), mode: mode, selectMode: selectMode, disabled: getDisabled(item), disabledMessage: getDisabledMessage(item), onSelect: onSelect, onBulkSelect: onBulkSelect })) }));
});
